import { QRCode } from 'antd'
import React from 'react'
import WebMain from './WebMain'

function Xiaofeng() {
    return (
        <WebMain selectedKeys="">
            <div
                style={{
                    width: '100%',
                    minHeight: '50vh',
                    backgroundColor: '#f5f5f5',
                    padding: '16px 12px',
                    boxSizing: 'border-box',
                }}
            >
                <div
                    style={{
                        maxWidth: '100%',
                        margin: '0 auto',
                        backgroundColor: '#fff',
                        borderRadius: 10,
                        padding: 16,
                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                    }}
                >
                    <h2
                        style={{
                            textAlign: 'center',
                            marginBottom: 16,
                            color: '#333',
                            fontSize: 18,
                        }}
                    >
                        三峡晓峰研学基地
                    </h2>
                    <div style={{ position: 'relative', width: '100%', maxWidth: '100%', margin: '0 auto' }}>
                        <video
                            controls
                            style={{
                                width: '100%',
                                height: 'auto',
                                borderRadius: 8,
                                outline: 'none',
                            }}
                            preload="metadata"
                            poster=""
                        >
                            <source
                                src="http://dianshangtaizhang.zzddww.com/assets/images/application/1761210221_6a6228a22f1649bb0c47.mp4"
                                type="video/mp4"
                            />
                            您的浏览器不支持视频播放。
                        </video>
                    </div>
                    <div
                        style={{
                            marginTop: 16,
                            color: '#666',
                            fontSize: 14,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                        }}
                    >
                        <p>点击播放按钮开始观看演示视频</p>
                        <a href="https://www.bnsrj.com" target="_blank" rel="noreferrer" style={{ marginTop: 12 }}>
                            技术支持：伯纳思软件
                        </a>
                        <div style={{ marginTop: 16 }}>
                            <QRCode value="https://www.bnsrj.com/H5Xiaofeng" size={180} />
                        </div>
                    </div>
                </div>
            </div>
        </WebMain>
    )
}

export default Xiaofeng
